import React from "react";

export const TriggerFloatingButtonIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
  >
    <path
      d="M6.49406 7.006H8.96419V4.03588H6.49406V7.006ZM2.03594 10.1016C1.7211 10.1016 1.45281 9.99075 1.23106 9.769C1.00931 9.54725 0.898438 9.27896 0.898438 8.96413V3.03588C0.898438 2.72104 1.00931 2.45275 1.23106 2.231C1.45281 2.00925 1.7211 1.89838 2.03594 1.89838H9.96419C10.279 1.89838 10.5473 2.00925 10.7691 2.231C10.9908 2.45275 11.1017 2.72104 11.1017 3.03588V8.96413C11.1017 9.27896 10.9908 9.54725 10.7691 9.769C10.5473 9.99075 10.279 10.1016 9.96419 10.1016H2.03594Z"
      fill="#4C4CF6"
    />
  </svg>
);
